import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import apiUrl from '../../../constants';

export default {
  name: 'RedisDashboard',
  components: { VueElementLoading },

  data() {
    return {
      isLoading: false,
      redisKeys: [],
      keyPattern: '*',
      exactKey: '',
      purgePattern: '',
      showUpdateModal: false,
      updateKeyData: { key: '', value: '', ttl: null },
    };
  },

  methods: {

    async fetchKeysByPattern() {
      if (!this.keyPattern.includes('*')) {
        alert("Pattern must include *");
        return;
      }
      this.isLoading = true;
      try {
        const res = await axios.get(apiUrl.api_url_hubops + `redis/list?pattern=${this.keyPattern}`);
        const keys = res.data.Data || [];
        this.redisKeys = keys.map(k => Object.assign({}, k, { _expanded: false }));
      } catch (err) {
        console.error(err);
        alert("Failed to fetch keys");
      } finally {
        this.isLoading = false;
      }
    },

    async fetchKeyByName() {
      if (!this.exactKey) return alert("Enter key name");
      this.isLoading = true;
      try {
        const res = await axios.post(apiUrl.api_url_hubops + 'redis/crud', {
          key: this.exactKey,
          value: '',
          operation: 'READ'
        });
        this.redisKeys = [{
          key: this.exactKey,
          value: res.data.RedisValue,
          ttl_seconds: res.data.TTL,
          expires_at: res.data.Metadata ? res.data.Metadata.expiresat : '',
          is_active: res.data.Metadata ? res.data.Metadata.isactive : false,
          _expanded: false
        }];
      } catch (err) {
        console.error(err);
        alert("Failed to fetch key");
      } finally {
        this.isLoading = false;
      }
    },

    updateKey(keyObj) {
      this.updateKeyData = Object.assign({}, keyObj);

      if (keyObj.value && typeof keyObj.value === 'object') {
        try {
          this.updateKeyData.value = JSON.stringify(keyObj.value, null, 2);
        } catch (err) {
          console.error('Failed to stringify value:', err);
          this.updateKeyData.value = String(keyObj.value);
        }
      }

      this.showUpdateModal = true;
    },

    async confirmUpdateKey() {
      try {
        const value = (() => {
          try {
            return JSON.parse(this.updateKeyData.value);
          } catch (err) {
            return this.updateKeyData.value;
          }
        })();

        await axios.post(apiUrl.api_url_hubops + 'redis/crud', {
          key: this.updateKeyData.key,
          value,
          ttl: this.updateKeyData.ttl,
          operation: 'UPDATE'
        });

        alert("Key updated successfully");
        this.showUpdateModal = false;
        this.fetchKeysByPattern();
      } catch (err) {
        console.error(err);
        alert("Failed to update key");
      }
    },

    async deleteKey(key) {
      if (!confirm(`Delete key "${key}"?`)) return;
      try {
        await axios.post(apiUrl.api_url_hubops + 'redis/crud', { key, value: '', operation: 'DELETE' });
        alert("Key deleted successfully");
        this.redisKeys = this.redisKeys.filter(k => k.key !== key);
      } catch (err) {
        console.error(err);
        alert("Failed to delete key");
      }
    },

    async purgeKeys() {
      if (!this.purgePattern.includes('*')) return alert("Pattern must include *");
      if (!confirm(`⚠️ This will permanently delete ALL keys matching "${this.purgePattern}". Continue?`)) return;

      this.isLoading = true;
      try {
        const res = await axios.post(apiUrl.api_url_hubops + 'redis/purge', { pattern: this.purgePattern });
        alert(res.data.ReturnMessage);
        this.purgePattern = '';
        this.fetchKeysByPattern();
      } catch (err) {
        console.error(err);
        alert("Failed to purge keys");
      } finally {
        this.isLoading = false;
      }
    },

    clearResults() {
      this.redisKeys = [];
    },

    formatValue(val) {
      if (val && typeof val === 'object') {
        try {
          return JSON.stringify(val, null, 2);
        } catch (e) {
          return String(val);
        }
      }
      return val;
    },

    isLongValue(val) {
      const str = this.formatValue(val);
      return str && str.length > 200;
    },

    toggleExpand(keyObj) {
      this.$set(keyObj, '_expanded', !keyObj._expanded);
    }
  },

  mounted() {
    this.fetchKeysByPattern();
  }
};



// WEBPACK FOOTER //
// ./src/views/components/RedisDashboard/RedisDashboard.js